import { render, staticRenderFns } from "./identification.view.vue?vue&type=template&id=0a10f0be&"
import script from "./identification.view.vue?vue&type=script&lang=ts&"
export * from "./identification.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports